<div class="fa-app-root">
  <app-header *ngIf="showAppHeader()"></app-header>
  <app-marketing-header *ngIf="showMarketingHeader()"></app-marketing-header>

  <!-- Full-bleed layout for auth or guide detail -->
  <ng-container *ngIf="isAuthRoute() || hideSidebar(); else regularLayout">
    <main class="main main--full">
      <app-prep-roadmap-switcher [compact]="isGuestStarterRoute()" [currentUrl]="currentUrl()"></app-prep-roadmap-switcher>
      <router-outlet></router-outlet>
    </main>
    <app-site-footer *ngIf="showSiteFooter()" [withPracticeBar]="footerAbovePracticeBar()"></app-site-footer>
    <app-sidebar *ngIf="showAppHeader() && sidebarDrawerOpen()" [drawerOnly]="true"></app-sidebar>
  </ng-container>

  <!-- Regular app pages -->
  <ng-template #regularLayout>
    <div class="app-layout">
      @defer (when showSidebar()) {
        <app-sidebar [collapsed]="isGuestStarterRoute()"></app-sidebar>
      }
      <div class="main-col">
        <main class="main">
          <app-prep-roadmap-switcher [compact]="isGuestStarterRoute()" [currentUrl]="currentUrl()"></app-prep-roadmap-switcher>
          <router-outlet></router-outlet>
        </main>
        <app-site-footer *ngIf="showSiteFooter()" [withPracticeBar]="footerAbovePracticeBar()"></app-site-footer>
      </div>
    </div>
  </ng-template>

  @defer (when premiumGateState().visible) {
    <app-premium-required-dialog
      [visible]="premiumGateState().visible"
      (visibleChange)="premiumGate.close()"
      [context]="premiumGateState().reason"
      [targetUrl]="premiumGateState().targetUrl"
      [isLoggedIn]="premiumGateState().isLoggedIn"
    ></app-premium-required-dialog>
  }

  @defer (when bugReport.visible()) {
    <app-bug-report-dialog></app-bug-report-dialog>
  }

  <app-achievement-toast></app-achievement-toast>
</div>
